import Box from '@mui/material/Box';
import { sk } from '../../styles/tl5';

// Reusable skeleton block. Compose into page-level skeletons that mirror
// the real layout (same sizes + spacing + radius) so the swap from
// skeleton to content is visually smooth.
//
// The sweep and its two tints come from the v5 `sk` primitive, so a loading
// page and the page it resolves into are the same temperature. They used to
// diverge: this block was tuned to the old cream palette and flashed warm
// beige before a cool mint page arrived.
//
// Props:
//   width     — CSS value (px, %, 'auto'). Default 100%.
//   height    — CSS value. Default 16.
//   rounded   — border-radius (number → px, or CSS string). Default 8.
//   circular  — shortcut for a round/avatar skeleton.
const Shimmer = ({
  width = '100%',
  height = 16,
  rounded = 8,
  circular = false,
  sx,
  ...rest
}) => (
  <Box
    sx={{
      ...sk,
      width,
      height,
      // A bare number in `sx.borderRadius` is a THEME MULTIPLE, not pixels —
      // theme.shape.borderRadius is 20 here, so `rounded={18}` was resolving
      // to 360px and every block came out fully round whatever was asked
      // for. Numbers are treated as pixels, which is what callers mean.
      borderRadius: circular ? '50%' : (typeof rounded === 'number' ? `${rounded}px` : rounded),
      flexShrink: 0,
      ...sx,
    }}
    {...rest}
  />
);

export default Shimmer;
